export { ComposedLabel } from "./ConfigurationLabelComposed";
